var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "submission-form" },
    [
      _c(
        "h1",
        {
          staticClass: "title has-text-primary",
          on: { click: _vm._felixIsLazy },
        },
        [_vm._v("Create New Project")]
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            "custom-class": "has-text-primary is-size-5",
            label: "Client Name",
          },
        },
        [
          _c("b-input", {
            attrs: { placeholder: "e.g. John and Jane Doe" },
            model: {
              value: _vm.clientName,
              callback: function ($$v) {
                _vm.clientName = $$v
              },
              expression: "clientName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            "custom-class": "has-text-primary is-size-5",
            label: "Project Address",
          },
        },
        [
          _c("b-input", {
            attrs: { placeholder: "e.g. 32 Kempson Way" },
            model: {
              value: _vm.projectAddress,
              callback: function ($$v) {
                _vm.projectAddress = $$v
              },
              expression: "projectAddress",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            "custom-class": "has-text-primary is-size-5",
            label: "Project Postcode",
          },
        },
        [
          _c("b-input", {
            attrs: { placeholder: "e.g. IP32 7AR" },
            model: {
              value: _vm.projectPostcode,
              callback: function ($$v) {
                _vm.projectPostcode = $$v
              },
              expression: "projectPostcode",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            "custom-class": "has-text-primary is-size-5",
            label: "Project start date (if known)",
          },
        },
        [
          _c("b-datepicker", {
            attrs: {
              "first-day-of-week": _vm.firstDayOfWeek,
              "icon-right": _vm.startDate ? "close-circle" : "",
              locale: _vm.locale,
              icon: "calendar",
              "icon-right-clickable": "",
              placeholder: "Click to select...",
              position: "is-top-left",
              rounded: "",
            },
            on: { "icon-right-click": _vm.clearDateTime },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "service-container" },
        [
          _c(
            "b-field",
            {
              attrs: {
                "custom-class": "has-text-primary is-size-5",
                "group-multiline": "",
                grouped: "",
                label: "Service",
                position: "is-centered",
              },
            },
            [
              _c(
                "b-field",
                [
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        active: _vm.tokensLeft.length === 0,
                        type: "is-danger",
                        label:
                          "You have no tokens left, please contact the office",
                      },
                    },
                    [
                      _c(
                        "b-radio",
                        {
                          attrs: {
                            "native-value": "PCE",
                            type: "is-primary",
                            disabled: _vm.tokensLeft.length === 0,
                          },
                          model: {
                            value: _vm.selectedService,
                            callback: function ($$v) {
                              _vm.selectedService = $$v
                            },
                            expression: "selectedService",
                          },
                        },
                        [_c("span", [_vm._v("Primary Cost Estimate")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-field",
                [
                  _c(
                    "b-radio",
                    {
                      attrs: {
                        "native-value": "Estimating Service",
                        type: "is-primary",
                      },
                      model: {
                        value: _vm.selectedService,
                        callback: function ($$v) {
                          _vm.selectedService = $$v
                        },
                        expression: "selectedService",
                      },
                    },
                    [_c("span", [_vm._v("Estimating Service")])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-field",
                [
                  _c(
                    "b-radio",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Coming Soon",
                          expression: "'Coming Soon'",
                        },
                      ],
                      attrs: {
                        disabled: "",
                        "native-value": "Self Estimating",
                        type: "is-primary",
                      },
                      model: {
                        value: _vm.selectedService,
                        callback: function ($$v) {
                          _vm.selectedService = $$v
                        },
                        expression: "selectedService",
                      },
                    },
                    [_vm._v("\n          Self-Estimating\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: !_vm.selectedService ? "Please select a service" : "",
              expression: "!selectedService ? 'Please select a service' : ''",
            },
          ],
          attrs: {
            "custom-class": "has-text-primary is-size-5",
            label: "Job Type",
          },
        },
        [
          _c(
            "p",
            { staticClass: "control" },
            [
              _c(
                "b-dropdown",
                {
                  attrs: {
                    "mobile-modal": true,
                    "open-on-focus": true,
                    "aria-role": "list",
                    expanded: "",
                    size: "is-medium",
                    disabled: !_vm.selectedService,
                  },
                  on: {
                    input: function (option) {
                      return (_vm.selectedJobType = option)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function (ref) {
                        var active = ref.active
                        return [
                          _c("b-input", {
                            attrs: {
                              "icon-right": active ? "caret-up" : "caret-down",
                              value: _vm.selectedJobType
                                ? _vm.selectedJobType.label
                                : "Select Job Type",
                              expanded: "",
                              readonly: "",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _vm._l(_vm.jobTypes, function (option) {
                    return _c(
                      "b-dropdown-item",
                      { key: option.name, attrs: { value: option } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(option.label) + "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("upload-files", {
        ref: "uploadFiles",
        staticClass: "upload-container",
        class: { expanded: _vm.selectedService === "Estimating Service" },
      }),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            label: "Additional Notes",
            "custom-class": "has-text-primary is-size-5",
          },
        },
        [
          _c("b-input", {
            attrs: { maxlength: "600", type: "textarea" },
            model: {
              value: _vm.additionalNotes,
              callback: function ($$v) {
                _vm.additionalNotes = $$v
              },
              expression: "additionalNotes",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedService
        ? _c(
            "b-field",
            { staticClass: "terms-and-conditions" },
            [
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.acceptedTerms,
                    callback: function ($$v) {
                      _vm.acceptedTerms = $$v
                    },
                    expression: "acceptedTerms",
                  },
                },
                [
                  _vm._v(
                    "\n      I confirm that I have read and understood the "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://projectestimator.co.uk/terms-conditions-estimating-services/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Terms and\n      Conditions")]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedService === "PCE"
        ? _c(
            "b-field",
            { staticClass: "terms-and-conditions" },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { type: "is-danger" },
                  model: {
                    value: _vm.acknowledgedTokenUse,
                    callback: function ($$v) {
                      _vm.acknowledgedTokenUse = $$v
                    },
                    expression: "acknowledgedTokenUse",
                  },
                },
                [
                  _vm._v(
                    "\n      I acknowledge that a token will be used to purchase the requested service, leaving me with "
                  ),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(_vm._s(_vm.tokensLeft.length - 1)),
                  ]),
                  _vm._v(" tokens.\n    "),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedService
        ? _c(
            "b-field",
            {
              attrs: {
                label:
                  _vm.selectedService === "Estimating Service"
                    ? "Promo code"
                    : "",
                "custom-class": "has-text-primary is-size-5",
                grouped: "",
                multiline: "",
                expanded: "",
              },
            },
            [
              _vm.selectedService === "Estimating Service"
                ? _c("b-input", {
                    model: {
                      value: _vm.promoCode,
                      callback: function ($$v) {
                        _vm.promoCode = $$v
                      },
                      expression: "promoCode",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "control mb-2 is-expanded" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "is-primary is-fullwidth has-text-white has-text-weight-semibold",
                      attrs: {
                        disabled:
                          !_vm.acceptedTerms ||
                          !_vm.selectedJobType ||
                          !_vm.selectedService ||
                          (!_vm.acknowledgedTokenUse &&
                            _vm.selectedService === "PCE"),
                        "icon-right": "paper-plane",
                        type: "button",
                      },
                      on: { click: _vm.submitProject },
                    },
                    [_vm._v("\n        Submit\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }